<template>
  <div class="terminal">
    <!-- <h1>acquirer</h1> -->
    <v-snackbar
      v-model="snackbar"
      :timeout="6000"
      :color="snackbar_color"
      location="top"
      max-height="10cm"
      max-width="5cm"
      multi-line
    >
      {{ snackbar_text }}
    </v-snackbar>

    <v-row no-gutters class="mt-2">
      <v-col cols="auto" class="me-auto">
        <!-- <v-sheet class="ma-2 pa-2">Acquirer</v-sheet> -->
        <v-sheet>
          <v-breadcrumbs
            :items="[{ text: $t('terminals'), disabled: true, href: '/' }]"
          ></v-breadcrumbs>
        </v-sheet>
      </v-col>
      <v-col cols="auto">
        <v-sheet>
          <v-btn
            class="button_size mr-3"
            color="blue"
            prepend-icon="mdi-plus"
            @click="compose"
            v-if="
              this.global_permissions.includes('ROLE_STAFF_ADMIN') ||
              this.global_permissions.includes('ROLE_STAFF_USER')
            "
          >
            <template v-slot:prepend>
              <v-icon color="white"></v-icon>
            </template>
            {{ $t("add_terminal") }}
          </v-btn>
        </v-sheet>
      </v-col>
      <v-col cols="auto">
        <v-sheet>
          <v-btn
            class="button_size"
            color="orange"
            prepend-icon="mdi-upload"
            @click="compose_excel"
            v-if="
              this.global_permissions.includes('ROLE_STAFF_ADMIN') ||
              this.global_permissions.includes('ROLE_STAFF_USER')
            "
          >
            <template v-slot:prepend>
              <v-icon color="white"></v-icon>
            </template>
            <span class="text_color">{{ $t("batch_upload") }}</span>
          </v-btn>
        </v-sheet>
      </v-col>
    </v-row>

    <v-row class="search_row">
      <v-col cols="3">
        <v-text-field
          append-inner-icon="mdi-close-circle"
          append-icon="mdi-magnify"
          density="compact"
          :label="$t('search')"
          variant="solo"
          hide-details
          single-line
          dense
          v-model="query"
          @click:append-inner="resetData"
          @click:append="searchData"
        ></v-text-field>
      </v-col>
      <v-col cols="auto mt-2">
        <v-sheet>
          <v-btn variant="text" @click="compose_select_organization" v-if="this.global_permissions.includes('ROLE_STAFF_ADMIN') || this.global_permissions.includes('ROLE_STAFF_USER') ">
            <span class="mr-1">{{ $t("export") }}</span>
            <v-icon color="grey-darken-1">mdi mdi-download</v-icon>            
          </v-btn>
        </v-sheet>
      </v-col>
    </v-row>

    <!-- Loading Spinner -->
    <v-progress-circular
      v-if="loading"
      indeterminate
      color="blue"
      size="25"
      class="loading-spinner"
    ></v-progress-circular>

    <v-card v-else>
      <v-data-table
        :headers="headers"
        :items="terminals"
        class="elevation-1 custom-table-style"
        :search="search"
        :items-per-page="itemsPerPage"
        :items-length="totalItems"
        disable-pagination
        :hide-default-footer="true"
        :fixed-header="true"
        :loading="loading"
      >
        <template v-slot:item.actions="{ item }">
          <!-- <v-icon color="green" small class="mr-2" @click="compose_update(item.value.acquirerId)" v-if="this.user_permissions.includes('Edit acquirer') || this.user_permissions.includes('All') ">mdi-pencil</v-icon>
              <v-icon color="red" small @click="compose_delete(item.value.acquirerId)" v-if="this.user_permissions.includes('Delete acquirer') || this.user_permissions.includes('All') ">mdi-delete</v-icon> -->
          <v-tooltip :text="$t('Update')" location="top">
            <template v-slot:activator="{ props }">
              <v-icon
                v-bind="props"
                small
                class="mr-2"
                color="green"
                @click="compose_update(item.raw.id)"
                v-if="
                  this.global_permissions.includes('ROLE_STAFF_ADMIN') ||
                  this.global_permissions.includes('ROLE_STAFF_USER')
                "
                >mdi-pencil-circle</v-icon
              >
            </template>
          </v-tooltip>
          <v-tooltip :text="$t('Delete')" location="top">
            <template v-slot:activator="{ props }">
              <v-icon
                v-bind="props"
                small
                class="mr-2"
                color="red"
                @click="compose_delete(item.raw.id)"
                v-if="this.global_permissions.includes('ROLE_STAFF_ADMIN')"
                >mdi-delete-circle</v-icon
              >
            </template>
          </v-tooltip>
        </template>

        <template v-slot:bottom>
          <div class="text-center pt-2">
            <v-pagination
              v-model="page"
              :length="pageCount"
              :total-visible="pageCount < 3 ? 3 : 7"
              @update:model-value="page"
            ></v-pagination>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <!-- ADD TERMINAL DIALOG -->
    <v-dialog v-model="dialog" persistent width="800">
      <v-card>
        <v-form ref="add Terminal" v-model="form" @submit.prevent="onSubmit">
          <v-container>
            <v-card-title>
              <span class="text-h5">{{ $t("add_terminal") }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      :label="$t('terminal_sn')"
                      :readonly="loading"
                       maxlength="10"
                      :rules="[required, validateSN]"
                      @change="checkSn(terminal_data.f_sn)"
                      clearable
                      v-model="terminal_data.f_sn"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <v-select
                      :items="models"
                      item-title="name"
                      item-value="id"
                      :label="$t('select_model')"
                      :rules="[required]"
                      v-model="terminal_data.f_model"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <v-select
                      :items="suppliers"
                      item-title="name"
                      item-value="id"
                      :label="$t('select_supplier')"
                      :rules="[required]"
                      v-model="terminal_data.f_supplier"
                    ></v-select>
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      :items="acquirers"
                      item-title="name"
                      item-value="id"
                      :label="$t('select_acquirer')"
                      :rules="[required]"
                      v-model="terminal_data.f_acquirer"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-container>
              <small>* {{ $t("indicateRequires") }}</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn variant="text" @click="dialog = false">
                {{ $t("Close") }}
              </v-btn>
              <v-btn
                color="success"
                type="submit"
                variant="text"
                @click="addTerminal"
              >
                {{ $t("Save") }}
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- END ADD ACQUIRER DIALOG -->

    <!-- UPDATE ACQUIRER DIALOG -->
    <v-dialog v-model="dialog_update" persistent width="800">
      <v-card>
        <v-form v-model="form" @submit.prevent="onSubmit">
          <v-container>
            <v-card-title>
              <span class="text-h5">{{ $t("update_terminal") }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      :label="$t('terminal_sn')"
                      :readonly="loading"
                      :rules="[required, validateSN]"
                      @change="checkSn(terminal_data.f_sn)"
                      clearable
                      v-model="terminal_data.f_sn"
                      maxlength="10"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <v-select
                      :items="models"
                      item-title="name"
                      item-value="id"
                      :label="$t('select_model')"
                      :rules="[required]"
                      v-model="terminal_data.f_model"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <v-select
                      :items="suppliers"
                      item-title="name"
                      item-value="id"
                      :label="$t('select_supplier')"
                      :rules="[required]"
                      v-model="terminal_data.f_supplier"
                    ></v-select>
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      :items="acquirers"
                      item-title="name"
                      item-value="id"
                      :label="$t('select_acquirer')"
                      :rules="[required]"
                      v-model="terminal_data.f_acquirer"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-container>
              <small>*{{ $t("indicateRequires") }}</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn variant="text" @click="dialog_update = false">
                {{ $t("Close") }}
              </v-btn>
              <v-btn
                color="success"
                type="submit"
                variant="text"
                @click="updateTerminal"
              >
                {{ $t("Update") }}
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- END UPDATE DIALOG -->

    <!-- DELETE DIALOG -->
    <!-- <v-dialog v-model="dialog_delete" persistent width="500">
      <v-card>
        <v-card-title>
          <div class="container">
            <span class="text-h5">{{ $t("do you want to delete") }} ?</span>
          </div>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row> </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue-darken-1"
            variant="text"
            @click="dialog_delete = false"
          >
            {{ $t("Close") }}
          </v-btn>
          <v-btn color="blue-darken-1" variant="text" @click="deleteTerminal">
            {{ $t("Delete") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->

    <v-dialog v-model="dialog_delete" persistent width="400">
      <v-card>
        <template v-slot:title>
          <span class="font-weight-medium-black">{{ $t("deleteFile") }}</span>
        </template>

        <v-card-text class="bg-surface-light py-4">
          {{ $t("deleteText") }}
        </v-card-text>
        <v-card-actions class="mb-2 mr-2">
          <v-spacer></v-spacer>
          <v-btn color="red" variant="flat" @click="deleteTerminal">{{
            $t("Delete")
          }}</v-btn>
          <v-btn variant="flat" @click="dialog_delete = false">{{
            $t("Close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- END UPDATE ACQUIRER DIALOG -->

    <!-- UPLOAD  DIALOG -->
    <v-dialog v-model="dialog_excel" persistent width="500">
      <v-card class="pa-3">
        <div class="container">
          <span style="text-align: center">{{ $t("batch_upload") }}</span>
        </div>

        <span style="text-align: center">
          <!-- THIS ALLOWS ME TO DOWNLOAD .XLS FILE -->
          <!-- <download-excel
                        class="btn btn-default"
                        :data="template_merchants"
                        :fields="template_json_fields"
                        worksheet="Merchants"
                        name="Merchants.xls"
                      >
                        <v-btn density="compact" color="black">Download Merchant Template</v-btn>
                      </download-excel> -->
          <!-- THIS ALLOWS ME TO DOWNLOAD .XLXS FILE -->
          <vue-excel-xlsx
            class="btn btn-default"
            :data="data1"
            :columns="template_columns"
            :file-name="'Terminals'"
            :file-type="'xlsx'"
            :sheet-name="'Terminals'"
          >
            <v-btn height="50" min-width="164"> {{ $t("download_template") }} </v-btn>
            <!-- <v-btn density="compact" color="black">Download Template</v-btn> -->
            <!-- Download Template -->
          </vue-excel-xlsx>
        </span>
        <v-form v-model="form" @submit.prevent="onSubmit">
          <v-card-title> </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <!-- <v-file-input show-size clearable label="File input" v-model="file" @change="handleFileUpload( $event )"></v-file-input> -->
                <v-file-input
                  show-size
                  clearable
                  label="File input"
                  @change="handleFileUpload($event)"
                ></v-file-input>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn variant="text" @click="dialog_excel = false">{{ $t('Close') }}</v-btn>
            <v-btn
              color="blue-darken-1"
              variant="text"
              @click="uploadTerminalFile"
              >{{ $t('Upload') }}</v-btn
            >
          </v-card-actions>
        </v-form>
        <div class="container">
          <small style="color: red"> *{{ $t('file_size') }}</small>
          <small style="color: red">
            {{ $t('uplaod_text') }}</small
          >
        </div>
      </v-card>
    </v-dialog>
    <!-- END UPLOAD FILE DIALOG -->

    <!-- SELECT ORGANIZATION FOR EXPORT -->
    <v-dialog v-model="dialog_select_organization" persistent width="700">
      <v-card>
        <v-form v-model="form" @submit.prevent="onSubmit">
          <v-container>
            <v-card-title>
              <span class="text-h5">Export Data</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">                            
                       <v-select
                        :items="organization"
                        item-title="orgName"
                        item-value="orgId"                          
                        label="Select organization"                          
                        :rules="[required]"                        
                        v-model="select_acquirer.f_acquirerId"
                      >                      
                      </v-select>                      
                    </v-col>                 
                  
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn variant="text" @click="dialog_select_organization = false">{{
                $t("Close")
              }}</v-btn>
              
              <v-btn variant="text" @click="exportTerminalData(this.select_acquirer.f_acquirerId)">
                <span class="mr-1">{{ $t("export") }}</span>
                <v-icon color="grey-darken-1">mdi mdi-download</v-icon>                
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- END SELECT ORGANIZATION FOR EXPORT -->
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Terminal",
  props: {
    msg: String,
  },
  data() {
    return {
      name: "",
      emits: ["reload"],
      terminals: [],
      acquirers: [],
      models: [],
      suppliers: [],
      organization: [],

      dialog: false,
      dialog_update: false,
      dialog_delete: false,
      dialog_excel: false, //for upload
      dialog_select_organization: false,

      terminal_data: {
        f_sn: "",
        f_model: "",
        f_supplier: "",
        f_acquirer: "",
      },

      terminalId: "",
      search: "",
      headers: [
        {
          title: this.$t("device_sn"),
          align: "start",
          sortable: false,
          key: "id",
        },
        { title: this.$t("model"), key: "terminalModel.modelName" },
        { title: this.$t("supplier"), key: "supplier.supplierName" },
        { title: this.$t("Acquirer"), key: "acquirer.acquirerName" },
        //{ title: "Organization", key: 'acquirer.organization.orgName' },
        {
          title: this.$t("Actions"),
          key: "actions",
          sortable: false,
          width: "100px",
        },
      ],

      //THIS IS USED TO CREATE A TEMPLATE XLXS FILE FOR DOWNLOAD
      //THE FIELD HAS TO BE ACCORDING TO THE NAMING IN THE ENTITY CLASS
      //NB: THE USER HAS TO DOWNLOADED ET RE SAVE  THE .XLXS FILE BEFORE IT WILL WORK
      template_columns: [
        {
          label: "Serial Number",
          field: "id",
        },
        {
          label: "Terminal Model",
          field: "terminalModel.id",
        },
        {
          label: "Supplier",
          field: "supplier.id",
        },
        {
          label: "Acquirer ID",
          field: "acquirer.id",
        },
        {
          label: "Created By",
          field: "createdBy",
        },
      ],
      // data1   HERE IS ACCORDING THE MERCHANT ENTITY
      data1: [
        {
          id: "",
          terminalModel: {
            id: "",
          },
          supplier: {
            id: "",
          },
          acquirer: {
            id: "",
          },
          createdBy: "",
        },
      ],

      //form
      form: false,
      loading: true,
      exist: false,

      //snackbar
      snackbar: false,
      snackbar_text: "",
      snackbar_color: "",

      //pagination
      page: 1,
      itemsPerPage: 5,
      totalItems: 0,
      totalPages: 0,
      query: "",

      //select org for export
      select_acquirer: {
        f_acquirerId: "",        
      }, 
    };
  },

  computed: {
    pageCount() {
      // console.log("ssss", this.totalItems + " / " + this.itemsPerPage);
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
  },

  watch: {
    page(newPage) {
      this.page = newPage;
      this.fetchData();
      // console.log("new page", this.page);
    },

    /* onUpdatePageHandler(newPage) {
          this.page = newPage
          //this.fetchData()
        }, */

    onItemsPerPageChange(newItemsPerPage) {
      this.itemsPerPage = newItemsPerPage;
      this.fetchData();
    },
  },
  methods: {
    resetData() {
      this.query = "";
      this.fetchData();
    },

    resetInput() {
      this.terminal_data.f_sn = "";
      this.terminal_data.f_model = "";
      this.terminal_data.f_supplier = "";
      this.terminal_data.f_acquirer = "";
    },

    onSubmit() {
      if (!this.form) return;
    },

    required(v) {
      return !!v || "Field is required";
    },

    compose() {
      this.dialog = true;
      this.resetInput();
      this.checkTokenExpiry();
      this.requests_handler();
    },

    compose_update(id) {
      this.terminalId = id;
      this.dialog_update = true;
      this.checkTokenExpiry();
      // console.log("id", id);
      this.requests_handler2();
    },

    compose_delete(id) {
      this.terminalId = id;
      this.dialog_delete = true;
    },

    compose_excel() {
      this.dialog_excel = true;
    },

    show_toast(status, color, text) {
      this.snackbar = status;
      this.snackbar_color = color;
      this.snackbar_text = text;
    },

    compose_select_organization() {
      this.dialog_select_organization = true;
      this.checkTokenExpiry();
      this.requests_handler4();
    },

    requests_handler4() {
      axios
        .all([
          axios.get(window.baseurl + "organizations", {            
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
        ])
        .then(
          axios.spread((org_response) => {
            // console.log("data1", acq_response.data);

            if (org_response.status == 200) {
              if (
                org_response.data.records != null &&
                org_response.data.records.length > 0
              ) {
                let i = 0;
                this.organization = []; //remove all items from array
                for (i = 0; i < org_response.data.records.length; i++) {
                  this.organization.push({
                    orgId: org_response.data.records[i].id,
                    orgName: org_response.data.records[i].orgName,
                  });
                  
                }
              }
            }
          })
        );
    }, //end of requests_handler4 method

    requests_handler() {
      //second method
      axios
        .all([
          axios.get(window.baseurl + "models", {
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
          axios.get(window.baseurl + "suppliers", {
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
          axios.get(window.baseurl + "acquirers", {
            params: { pagesize: 100 },
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
        ])
        .then(
          axios.spread((first_response, second_response, third_response) => {
            // console.log("data1", first_response.data);

            if (first_response.status == 200) {
              if (
                first_response.data.records != null &&
                first_response.data.records.length > 0
              ) {
                let i = 0;
                this.models = []; //remove all items from array
                for (i = 0; i < first_response.data.records.length; i++) {
                  this.models.push({
                    id: first_response.data.records[i].id,
                    name: first_response.data.records[i].modelName,
                  });
                }
              }
            }

            if (second_response.status == 200) {
              if (
                second_response.data.records != null &&
                second_response.data.records.length > 0
              ) {
                let i = 0;
                this.suppliers = []; //remove all items from array
                for (i = 0; i < second_response.data.records.length; i++) {
                  this.suppliers.push({
                    id: second_response.data.records[i].id,
                    name: second_response.data.records[i].supplierName,
                  });
                }
              }
            }

            if (third_response.status == 200) {
              if (
                third_response.data.records != null &&
                third_response.data.records.length > 0
              ) {
                let i = 0;
                this.acquirers = []; //remove all items from array
                for (i = 0; i < third_response.data.records.length; i++) {
                  this.acquirers.push({
                    id: third_response.data.records[i].id,
                    name: third_response.data.records[i].acquirerName,
                  });
                }
              }
            }
          })
        );
    }, //end of requests_handler method

    async addTerminal() {
      //this.dialog = false
      this.checkTokenExpiry();

      if (this.exist) {
        this.$root.vtoast.showError({ message: this.$t("terminal_exist") });
      } else {
        // console.log("form data", this.terminal_data);
        try {
          let result = await axios.post(
            window.baseurl + "terminals",
            {
              id: this.terminal_data.f_sn,
              supplier_id: this.terminal_data.f_supplier,
              model_id: this.terminal_data.f_model,
              acquirer_id: this.terminal_data.f_acquirer,
              createdBy: this.userEmail,
              updatedBy: this.userEmail,
            },
            { headers: { Authorization: "Bearer " + this.accessToken } }
          );
          //console.warn("result", result);
          if (result.status == 201) {
            //alert("log in successfull");
            //this.show_toast(true, "success", "Successful");
            // this.$root.vtoast.show({ message: result.data.message });
            this.$root.vtoast.show({ message: this.$t("terminal_created") });
            window.setInterval(() => {
              this.dialog = false;
              this.$emit("reload");
            }, this.waiting_time);
          }
        } catch (error) {
          // console.warn("error", error.response);
          //this.show_toast(true, "warning", error.response.data.message);
          if (error.response.status == 417) {
            this.$root.vtoast.showError({
              message: error.response.data.message,
            });
          } else if (error.response.status == 500) {
            this.$root.vtoast.showError({
              message: error.response.data.detail,
            });
          } else {
            this.$root.vtoast.showError({
              message: error.response.data.message,
            });
          }
        }
      }
    },

    requests_handler2() {
      axios
        .all([
          axios.get(window.baseurl + "terminals/" + "" + this.terminalId, {
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
          axios.get(window.baseurl + "models", {
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
          axios.get(window.baseurl + "suppliers", {
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
          axios.get(window.baseurl + "acquirers", {
            params: { pagesize: 100 },
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
        ])
        .then(
          axios.spread(
            (
              term_response,
              first_response,
              second_response,
              third_response
            ) => {
              // console.log("term", term_response.data);

              //get acquirer data for selected id and display data in for dialog
              if (term_response.status == 200) {
                this.terminal_data.f_sn = term_response.data.id;
                this.terminal_data.f_model =
                  term_response.data.terminalModel.id;
                this.terminal_data.f_supplier = term_response.data.supplier.id;
                this.terminal_data.f_acquirer = term_response.data.acquirer.id;
              }

              if (first_response.status == 200) {
                if (
                  first_response.data.records != null &&
                  first_response.data.records.length > 0
                ) {
                  let i = 0;
                  this.models = []; //remove all items from array
                  for (i = 0; i < first_response.data.records.length; i++) {
                    this.models.push({
                      id: first_response.data.records[i].id,
                      name: first_response.data.records[i].modelName,
                    });
                  }
                }
              }

              if (second_response.status == 200) {
                if (
                  second_response.data.records != null &&
                  second_response.data.records.length > 0
                ) {
                  let i = 0;
                  this.suppliers = []; //remove all items from array
                  for (i = 0; i < second_response.data.records.length; i++) {
                    this.suppliers.push({
                      id: second_response.data.records[i].id,
                      name: second_response.data.records[i].supplierName,
                    });
                  }
                }
              }

              if (third_response.status == 200) {
                if (
                  third_response.data.records != null &&
                  third_response.data.records.length > 0
                ) {
                  let i = 0;
                  this.acquirers = []; //remove all items from array
                  for (i = 0; i < third_response.data.records.length; i++) {
                    this.acquirers.push({
                      id: third_response.data.records[i].id,
                      name: third_response.data.records[i].acquirerName,
                    });
                  }
                }
              }
            }
          )
        );
    }, //end of requests_handler 2 method

    async updateTerminal() {
      this.checkTokenExpiry();
      if (this.exist) {
        this.$root.vtoast.showError({ message: this.$t("terminal_exist") });
      } else {
        try {
          // console.log("update form acquirer id", this.terminalId);
          // console.log("update form acquirer", this.terminal_data);
          let result = await axios.put(
            window.baseurl + "terminals/" + this.terminalId,
            {
              id: this.terminal_data.f_sn,
              supplier_id: this.terminal_data.f_supplier,
              model_id: this.terminal_data.f_model,
              acquirer_id: this.terminal_data.f_acquirer,
              createdBy: this.userEmail,
              updatedBy: this.userEmail,
            },
            { headers: { Authorization: "Bearer " + this.accessToken } }
          );
          // console.log("update form acquirer result", result);
          if (result.status == 200) {
            //alert("successfull updated");
            //this.show_toast(true, "success", "Successful");
            // this.$root.vtoast.show({ message: result.data.message });
            this.$root.vtoast.show({ message: this.$t("terminal_updated") });
            window.setInterval(() => {
              this.dialog_update = false;
              this.$emit("reload");
            }, this.waiting_time);
          }
        } catch (error) {
          //this.show_toast(true, "warning", error.response.data.message);
          if (error.response.status == 417) {
            this.$root.vtoast.showError({
              message: error.response.data.message,
            });
          } else if (error.response.status == 500) {
            this.$root.vtoast.showError({
              message: error.response.data.detail,
            });
          } else {
            this.$root.vtoast.showError({
              message: error.response.data.message,
            });
          }
        }
      }
    },

    async deleteTerminal() {
      this.dialog_delete = false;
      this.checkTokenExpiry();
      try {
        let result = await axios.delete(
          window.baseurl + "terminals/" + this.terminalId,
          { headers: { Authorization: "Bearer " + this.accessToken } }
        );
        //console.log("update form acquirer result", result)
        if (result.status == 204) {
          //alert("successfull updated");
          //this.show_toast(true, "success", "Deleted");
          // this.$root.vtoast.show({ message: result.data.message });
          this.$root.vtoast.show({ message: this.$t("terminal_deleted") });
          window.setInterval(() => {
            this.$emit("reload");
          }, this.waiting_time);
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.response.data.message);
        this.$root.vtoast.showError({ message: error.response.data.error });
      }
    },

    //CHECK IF SN IN FORM EXSIT
    async checkSn(sn) {
      this.exist = false;
      // console.log("user email", sn);
      this.checkTokenExpiry();

      try {
        let result_email = await axios.get(window.baseurl + "terminals/" + sn, {
          headers: { Authorization: "Bearer " + this.accessToken },
        });
        // console.log("RESPONSE", result_email);
        if (result_email.status == 200) {
          this.$root.vtoast.showError({ message: sn + "  exist" });
          // console.log("EXIST", "sn exist");
          this.exist = true;
        }
      } catch (err) {
        // console.log("EXIST", "sn does not exist");
        // console.log(err.response.data);
        this.exist = false;
      }
    },

    //UPLOAD FILE

    handleFileUpload(event) {
      this.file = event.target.files[0];
    },

    async uploadTerminalFile() {
      // console.log("file" + this.file);
      this.checkTokenExpiry();
      if (this.file) {
        this.loading = true;
        let formData = new FormData();
        formData.append("file", this.file);
        try {
          let result = await axios.post(
            window.baseurl + "terminals/upload",
            formData,
            {
              headers: {
                Authorization: "Bearer " + this.accessToken,
                "content-type": "multipart/form-data",
              },
            }
          );
          //console.warn("result", result);
          if (result.status == 201) {
            //alert("successfull");
            //this.show_toast(true, "success", "Successful");
            // this.$root.vtoast.show({ message: result.data.message });
            this.$root.vtoast.show({ message:  this.$t("terminal_uploaded")});
            window.setInterval(() => {
              this.dialog_excel = false;
              this.$emit("reload");
            }, this.waiting_time);
          }
          this.loading = false;
        } catch (error) {
          //this.show_toast(true, "warning", error.message);
          // console.log("Error", error);
          this.loading = false;
          if(error.response.status == 417){
            this.$root.vtoast.showError({message: error.response.data.message})
          }else if(error.response.status == 500){
            this.$root.vtoast.showError({message: error.response.data.detail})
          }else{
            this.$root.vtoast.showError({message: error.response.data.message})
          }
          // this.$root.vtoast.showError({ message: error.message });
        }
      } else {
        // console.log("there are no files.");
        this.$root.vtoast.showError({ message: this.$t("no_file") });
      }
    },

    async fetchData() {
      let page2 = this.page - 1;
      this.loading = true;
      let result;
      try {
        if (
          this.global_permissions.includes("ROLE_STAFF_ADMIN") ||
          this.global_permissions.includes("ROLE_STAFF_USER")
        ) {
          result = await axios.get(window.baseurl + "terminals", {
            params: { page: page2 },
            headers: { Authorization: "Bearer " + this.accessToken },
          });

          // console.log("terminal_object", result);
          this.terminals = result.data.records;
          this.totalItems = result.data.totalRecords; // Set the total number of items
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          this.loading = false;
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.response.data.message);
        this.$root.vtoast.showError({ message: error.response.data.message });
        this.loading = false;
      }
    },

    async searchData() {
      // console.log("in searchData", this.query);
      this.checkTokenExpiry();
      let result;
      this.loading = true;
      let page2 = this.page - 1;
      try {
        if (
          this.global_permissions.includes("ROLE_STAFF_ADMIN") ||
          this.global_permissions.includes("ROLE_STAFF_USER")
        ) {
          result = await axios.get(window.baseurl + "terminals/search", {
            params: { page: page2, search: this.query },
            headers: { Authorization: "Bearer " + this.accessToken },
          });

          // console.log("terminals_object", result);
          this.terminals = result.data.records;
          this.totalItems = result.data.totalRecords; // Set the total number of items
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          this.loading = false;
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        this.$root.vtoast.showError({ message: error.message });
        this.loading = false;
      }
    },

    async downloadExcel2(orgId) {
      this.loading = true;
      try {
        
        const response = await fetch(window.baseurl + "terminals/export/org/" + orgId, {
          method: 'GET',
          headers: {
            'Accept': 'application/octet-stream',
            Authorization: "Bearer " + this.accessToken ,
          },
        }); 
        console.error('response.', response);   
        if (response.status == 200) {          
          const blob = await response.blob();  // Convert the response to a blob (binary data)          
          const url = window.URL.createObjectURL(blob);  // Create a URL for the blob
          const link = document.createElement('a');  // Create a temporary download link
          link.href = url;
          // Base file name
          const baseFileName = "Terminal";
          // Get current date and time
          const now = new Date();
          const formattedDate = now.toISOString().slice(0, 19).replace(/:/g, "-");
          // Combine base file name with date and time
          const fileName = `${baseFileName}_${formattedDate}.xlsx`;
          link.setAttribute('download', fileName);  // Set the file name
          document.body.appendChild(link);
          link.click();  // Simulate a click to trigger the download
          document.body.removeChild(link);  // Clean up
        } else {
          console.error('Failed to download the file.');
        }
        this.loading = false;
      } catch (error) {
        console.error('Error downloading the file:', error);
        this.loading = false;
      }
    },

    async exportTerminalData(id) {      
      //console.log("merchant_object44", id);      
      this.downloadExcel2(id);
      this.dialog_select_organization = false;     
    },

    validateSN(value) {
      const regex = /^[0-9]{10}$/;
      return (
        regex.test(value) ||
        "Serial Number can only be numbers and 10 characters long."
      );
    },
  },
  //get list of acquirers
  async mounted() {
    this.checkTokenExpiry();

    //get list
    this.fetchData();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.search_row {
  margin-top: 5px;
  margin-bottom: 5px;
}
</style>
